// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/tick.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .todonav{
    font-weight: 600;
    border: none !important;
    gap: 30px;
    width: auto;
    padding: 2px 30px;
    font-size: 19px;
  } */
  .input-container {
    position: relative;
    display: inline-block;
  }
  .todonav .nav-link.active{
    border: none;
    border-bottom:  solid #009345!important;
    color: #009345!important;
 
  }
  .todonav .nav-link{
    color: gray !important;
    border: none;
    padding-top: 0px;
   padding-bottom: 2px;
   
  }

.due-date{
  position: absolute;
  top: 8px;
  right: 75px;
  transform: translateY(-50%);
}

  /*todo.css*/
  .todonav{
    font-weight: 500 !important;
    border: none;
    gap: 30px;
    width: auto;
    padding: 2px 4px !important;
    font-size: 17px !important;
  }
  .input-container {
    position: relative;
    display: inline-block;
  }
  
  .input-container .form-control {
    padding-right: 30px; /* Adjust the padding to leave space for the icon */
    background: url('https://beta.doneapp.ai/build/assets/date-3aba8fa1.png')
      no-repeat right center;
    background-size: 20px 20px; /* Adjust the size of the icon */
    font-size: 15px;
  }
  .dateicon {
    position: absolute;
    right: 80px; /* Adjust the position of the icon */
    top: 50%;
    transform: translateY(-50%);
  }
  .date-width{
    width:255px;
    background-color: #FFFF;
    border: solid 1px #dee2e6;
    border-radius: 7px;
  }
  .dateicon img {
    width: 21px;
}
.custm-radio{
  border-radius: 50% !important;
  background-color: #fff;
  border: 3px solid #009933 !important;
  padding: 10px;
}
.form-check-input:checked{
  border-color: none;
  outline: none;
}
.form-check-input:focus {
  border-color:none;}
.posticon {
  text-align: justify;
  padding-left: 5px;
  line-height: 20px;
}
.doneheading{
  gap: 5px;
  align-items: start;
}
.tdata {
 
  overflow: hidden;
  border-top: 0;
  border-right: 0;
  border-left: 0;
}
.font-size{
  font-size: 10px;
  padding-left: 5px;
}
/* button.accordion-button {
  margin-left: 20px;
} */
.nav-link.active{
  color:#009933 !important
}

.taskborder {
  border-bottom: 1px solid #8080807d;
  padding: 5px;
}
.videpart {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.taskbtn img {
  width: 10px;
  vertical-align: baseline;
  margin-right: 4px;
}
.taskbtn {
  color: #7c7a7acf;
  font-family: Goldplay-bold;
}
a {
  text-decoration: none;
}
.submitclass img {
  width: 35px;
}
.add-input{
  background: none
}
.videpart input {
  font-size: 18px;
}
.side-bar .menu .item a {
  display: block;
  color: #1a1a1a;
}
.side-bar .menu .item .sub-menu a {
  padding: 3px 0 8px;
}
.inner-accordian{
  padding-top:15px;
}
.sub-btn{
  color: #1a1a1a;
  gap:18px;
  justify-content: center;
  align-items: center;
}
.accordian-outer-button{
  color: #1a1a1a !important; 
}
.listoption {
  background-color: #f7f7f7;
  padding: 20px 30px;
  border-radius: 12px;
}
.list-group-item{
  background: none !important;
  border: none;
}
.listoption {
  font-weight: bolder;
  color: gray;
  font-size: 19px;
  padding: 10px, 30px;
   
}
.rightgrey {
  width: 13px;
  vertical-align: initial;
}
.binclass{
  font-size: 17px;
   color: gray;
}
.accordian-text{
  color: gray;
}
.greysearchimg{
  background-color: #f1f1f3;
  border-radius: 26px;
  border-color: transparent;
}
.todosearch{
  background-color: #f1f1f3;
  border-radius: 20px;
}
.scrollable {
  overflow-y: auto;
  height: calc(68vh - 100px);
}

.edit-input{
  height: 32px;
  font-size: 32px;
}
.edit-input1 {
  height: 32px;
  font-size: 13px;
  width: 50%;
}
.sub-task{
  outline:none;
   width:100%
}
.list-style{
  list-style-type: disc;
  padding-left: 5px;
  margin-left: 100px;
}
.custom-file-upload {
  display: inline-block;
  position: relative;
  cursor: pointer;
}

.custom-file-input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  cursor: pointer;
}


.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.loading-gif {
  width: 50px;
  /* Adjust the width of your loading GIF */
  height: 50px;
  /* Adjust the height of your loading GIF */
}
.updated-at{
  font-size: 11px;
  line-height: 12px;
  color: #212529;
}
.custm-checkbox{
  width: 25px;
  height: 25px;
  border-radius: 50% !important;
  border: solid 3px #009933 !important;
}
.text-padding {
  padding: 32px; 
}
.main-posts{
  color: rgb( 33, 37, 41);
  opacity: 1;
}
.form-check-input:checked[type=radio] {
    --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.form-check-input[type=radio] {
  border-radius: 50%;
  border: solid 3px #009933;
}
.hidden-popup{
visibility: hidden;
}
/* .text-blue{
  color: #3b3cfb;
  text-shadow: 0 0 hsl(239.69deg 96% 60.78%);
  font-size: 13px;
  padding: 0,0,0,8px;
} */
.text-area{
  font-size: 13px;
  color: #212529;
  background-color: #ffff;
  padding: .375rem .75rem;
  width: 638px !important;
  height: 92px;
  border: solid 2px #dee2e6
}
.heighttodos{
  height: 58vh;
    overflow-x: hidden;
    position: relative;
}

.accordion-headers{
  background-color: #ffff
}
.Addtask{
  padding: 10px 10px 5px ;
}

.videpart input {
  font-size: 16px;
}
.addtaskpart {
  border: 1px solid #cdcdcd;
  border-radius: 8px;
  padding: 2px 20px 0px;
  position:"fixed";
  top: 0;
   right: 0;
}
.minitodo-checkbox{
  width: 16px;
  height: 16px;
}
.accordian-sort{
  background-color: #ebe2e200 ;
}
/*saipriya changes*/
.home-todo{
  font-size: 16px;
  color: #777272!important;
}
.tab-border{
  border-bottom: 1px solid #beb8b873 !important;
}
.tab-nav{
  padding: 2px 10px !important;
}
@media screen and (min-width: 768px) and (max-width: 991px) {
  .icons{
    padding: 0px;
  }
}
.box{
  background-color:#e2e0e0;
  width: 101%;
  height: 39px;
  border-radius: 20px;
}
.box1{
  background-color:#e2e0e0;
  height: 450px;
  width: 101%;
  border-radius: 6px;
}
.groupstatic{
  background-color:#e2e0e0;
  width: 25%;
  height: 18px;
  /* border-radius:5px ; */
}
.groupstatic1{
  background-color:#e2e0e0;
  width: 60%;
  height: 18px;
}
.post1{
  background-color:#e2e0e0;
  width: 40%;
  height: 33px;
}
.post2{
  background-color:#e2e0e0;
  width: 95%;
  height: 240px;
  border-radius: 5px;
}
.post3{
  background-color:#e2e0e0;
  width: 95%;
  height: 450px;
  border-radius: 5px;
}
.image-video{
  background-color:#e2e0e0;
  width: 100%;
  height: 300px;
}
.text-static{
  background-color:#e2e0e0;
  width: 100%;
  height: 42px;
  border-radius: 5px;
}
.profilestatic{
  background-color:#e2e0e0;
  border-radius: 50%;
  height: 30px;
  width: 30px;
}
.profilestatic1 {
  background-color:#e2e0e0;
  height: 15px;
  width: 182px;
}
.chatp-static{
  background-color:#e2e0e0;
  border-radius: 50%;
  height: 50px;
  width: 50px;
}
.chatt-static{
  background-color:#e2e0e0;
  height: 42px;
  width: 316px;
}
.check-static{
  width: 26px;
  height: 26px;
  border-radius: 50% ;
 background-color: #e2e0e0;
}
.date-static{
  background-color:#e2e0e0;
  height: 12px;
  width: 130px;
}
.check-static1{
  width: 22px;
  height: 22px;
  border-radius: 12% ;
 background-color: #e2e0e0;
}
.post4{
  width: 95%;
  height: 240px;
}
.post5{
  width: 95%;
  height: 100px;
}
.static-post{
   background-color:#f2f2f2;
   width: 100%;
   height: 45px;
   border-radius: 5px;
}
@media screen and  (max-width:576px){
  .todos-pl{
    padding-left: 8px !important;
  }
  .due-date{
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/todos/Todo.css"],"names":[],"mappings":"AAAA;;;;;;;KAOK;EACH;IACE,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,YAAY;IACZ,uCAAuC;IACvC,wBAAwB;;EAE1B;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;GACjB,mBAAmB;;EAEpB;;AAEF;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;EAEE,WAAW;EACX;IACE,2BAA2B;IAC3B,YAAY;IACZ,SAAS;IACT,WAAW;IACX,2BAA2B;IAC3B,0BAA0B;EAC5B;EACA;IACE,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB,EAAE,mDAAmD;IACxE;4BACwB;IACxB,0BAA0B,EAAE,gCAAgC;IAC5D,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,WAAW,EAAE,oCAAoC;IACjD,QAAQ;IACR,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,uBAAuB;IACvB,yBAAyB;IACzB,kBAAkB;EACpB;EACA;IACE,WAAW;AACf;AACA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB,CAAC;AACpB;EACE,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,QAAQ;EACR,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;GAEG;AACH;EACE;AACF;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,wBAAwB;EACxB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,WAAW;AACb;AACA;EACE;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;EACd,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;;AAErB;AACA;EACE,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,eAAe;GACd,WAAW;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;AACA;EACE,YAAY;GACX;AACH;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,QAAQ;EACR,MAAM;EACN,UAAU;EACV,eAAe;AACjB;;;AAGA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,UAAU;AACZ;AACA;IACI,iEAAsD;AAC1D;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;AACA,kBAAkB;AAClB;AACA;;;;;GAKG;AACH;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ;AACF;AACA;EACE,YAAY;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;EACE;AACF;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,MAAM;GACL,QAAQ;AACX;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,4BAA4B;AAC9B;AACA,mBAAmB;AACnB;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,4BAA4B;AAC9B;AACA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,aAAa;AACf;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;AACA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;CACpB,yBAAyB;AAC1B;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;CACpB,yBAAyB;AAC1B;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;GACG,wBAAwB;GACxB,WAAW;GACX,YAAY;GACZ,kBAAkB;AACrB;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* .todonav{\n    font-weight: 600;\n    border: none !important;\n    gap: 30px;\n    width: auto;\n    padding: 2px 30px;\n    font-size: 19px;\n  } */\n  .input-container {\n    position: relative;\n    display: inline-block;\n  }\n  .todonav .nav-link.active{\n    border: none;\n    border-bottom:  solid #009345!important;\n    color: #009345!important;\n \n  }\n  .todonav .nav-link{\n    color: gray !important;\n    border: none;\n    padding-top: 0px;\n   padding-bottom: 2px;\n   \n  }\n\n.due-date{\n  position: absolute;\n  top: 8px;\n  right: 75px;\n  transform: translateY(-50%);\n}\n\n  /*todo.css*/\n  .todonav{\n    font-weight: 500 !important;\n    border: none;\n    gap: 30px;\n    width: auto;\n    padding: 2px 4px !important;\n    font-size: 17px !important;\n  }\n  .input-container {\n    position: relative;\n    display: inline-block;\n  }\n  \n  .input-container .form-control {\n    padding-right: 30px; /* Adjust the padding to leave space for the icon */\n    background: url('https://beta.doneapp.ai/build/assets/date-3aba8fa1.png')\n      no-repeat right center;\n    background-size: 20px 20px; /* Adjust the size of the icon */\n    font-size: 15px;\n  }\n  .dateicon {\n    position: absolute;\n    right: 80px; /* Adjust the position of the icon */\n    top: 50%;\n    transform: translateY(-50%);\n  }\n  .date-width{\n    width:255px;\n    background-color: #FFFF;\n    border: solid 1px #dee2e6;\n    border-radius: 7px;\n  }\n  .dateicon img {\n    width: 21px;\n}\n.custm-radio{\n  border-radius: 50% !important;\n  background-color: #fff;\n  border: 3px solid #009933 !important;\n  padding: 10px;\n}\n.form-check-input:checked{\n  border-color: none;\n  outline: none;\n}\n.form-check-input:focus {\n  border-color:none;}\n.posticon {\n  text-align: justify;\n  padding-left: 5px;\n  line-height: 20px;\n}\n.doneheading{\n  gap: 5px;\n  align-items: start;\n}\n.tdata {\n \n  overflow: hidden;\n  border-top: 0;\n  border-right: 0;\n  border-left: 0;\n}\n.font-size{\n  font-size: 10px;\n  padding-left: 5px;\n}\n/* button.accordion-button {\n  margin-left: 20px;\n} */\n.nav-link.active{\n  color:#009933 !important\n}\n\n.taskborder {\n  border-bottom: 1px solid #8080807d;\n  padding: 5px;\n}\n.videpart {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.taskbtn img {\n  width: 10px;\n  vertical-align: baseline;\n  margin-right: 4px;\n}\n.taskbtn {\n  color: #7c7a7acf;\n  font-family: Goldplay-bold;\n}\na {\n  text-decoration: none;\n}\n.submitclass img {\n  width: 35px;\n}\n.add-input{\n  background: none\n}\n.videpart input {\n  font-size: 18px;\n}\n.side-bar .menu .item a {\n  display: block;\n  color: #1a1a1a;\n}\n.side-bar .menu .item .sub-menu a {\n  padding: 3px 0 8px;\n}\n.inner-accordian{\n  padding-top:15px;\n}\n.sub-btn{\n  color: #1a1a1a;\n  gap:18px;\n  justify-content: center;\n  align-items: center;\n}\n.accordian-outer-button{\n  color: #1a1a1a !important; \n}\n.listoption {\n  background-color: #f7f7f7;\n  padding: 20px 30px;\n  border-radius: 12px;\n}\n.list-group-item{\n  background: none !important;\n  border: none;\n}\n.listoption {\n  font-weight: bolder;\n  color: gray;\n  font-size: 19px;\n  padding: 10px, 30px;\n   \n}\n.rightgrey {\n  width: 13px;\n  vertical-align: initial;\n}\n.binclass{\n  font-size: 17px;\n   color: gray;\n}\n.accordian-text{\n  color: gray;\n}\n.greysearchimg{\n  background-color: #f1f1f3;\n  border-radius: 26px;\n  border-color: transparent;\n}\n.todosearch{\n  background-color: #f1f1f3;\n  border-radius: 20px;\n}\n.scrollable {\n  overflow-y: auto;\n  height: calc(68vh - 100px);\n}\n\n.edit-input{\n  height: 32px;\n  font-size: 32px;\n}\n.edit-input1 {\n  height: 32px;\n  font-size: 13px;\n  width: 50%;\n}\n.sub-task{\n  outline:none;\n   width:100%\n}\n.list-style{\n  list-style-type: disc;\n  padding-left: 5px;\n  margin-left: 100px;\n}\n.custom-file-upload {\n  display: inline-block;\n  position: relative;\n  cursor: pointer;\n}\n\n.custom-file-input {\n  position: absolute;\n  font-size: 100px;\n  right: 0;\n  top: 0;\n  opacity: 0;\n  cursor: pointer;\n}\n\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(255, 255, 255, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n}\n\n.loading-gif {\n  width: 50px;\n  /* Adjust the width of your loading GIF */\n  height: 50px;\n  /* Adjust the height of your loading GIF */\n}\n.updated-at{\n  font-size: 11px;\n  line-height: 12px;\n  color: #212529;\n}\n.custm-checkbox{\n  width: 25px;\n  height: 25px;\n  border-radius: 50% !important;\n  border: solid 3px #009933 !important;\n}\n.text-padding {\n  padding: 32px; \n}\n.main-posts{\n  color: rgb( 33, 37, 41);\n  opacity: 1;\n}\n.form-check-input:checked[type=radio] {\n    --bs-form-check-bg-image: url(\"../../images/tick.jpg\");\n}\n.form-check-input[type=radio] {\n  border-radius: 50%;\n  border: solid 3px #009933;\n}\n.hidden-popup{\nvisibility: hidden;\n}\n/* .text-blue{\n  color: #3b3cfb;\n  text-shadow: 0 0 hsl(239.69deg 96% 60.78%);\n  font-size: 13px;\n  padding: 0,0,0,8px;\n} */\n.text-area{\n  font-size: 13px;\n  color: #212529;\n  background-color: #ffff;\n  padding: .375rem .75rem;\n  width: 638px !important;\n  height: 92px;\n  border: solid 2px #dee2e6\n}\n.heighttodos{\n  height: 58vh;\n    overflow-x: hidden;\n    position: relative;\n}\n\n.accordion-headers{\n  background-color: #ffff\n}\n.Addtask{\n  padding: 10px 10px 5px ;\n}\n\n.videpart input {\n  font-size: 16px;\n}\n.addtaskpart {\n  border: 1px solid #cdcdcd;\n  border-radius: 8px;\n  padding: 2px 20px 0px;\n  position:\"fixed\";\n  top: 0;\n   right: 0;\n}\n.minitodo-checkbox{\n  width: 16px;\n  height: 16px;\n}\n.accordian-sort{\n  background-color: #ebe2e200 ;\n}\n/*saipriya changes*/\n.home-todo{\n  font-size: 16px;\n  color: #777272!important;\n}\n.tab-border{\n  border-bottom: 1px solid #beb8b873 !important;\n}\n.tab-nav{\n  padding: 2px 10px !important;\n}\n@media screen and (min-width: 768px) and (max-width: 991px) {\n  .icons{\n    padding: 0px;\n  }\n}\n.box{\n  background-color:#e2e0e0;\n  width: 101%;\n  height: 39px;\n  border-radius: 20px;\n}\n.box1{\n  background-color:#e2e0e0;\n  height: 450px;\n  width: 101%;\n  border-radius: 6px;\n}\n.groupstatic{\n  background-color:#e2e0e0;\n  width: 25%;\n  height: 18px;\n  /* border-radius:5px ; */\n}\n.groupstatic1{\n  background-color:#e2e0e0;\n  width: 60%;\n  height: 18px;\n}\n.post1{\n  background-color:#e2e0e0;\n  width: 40%;\n  height: 33px;\n}\n.post2{\n  background-color:#e2e0e0;\n  width: 95%;\n  height: 240px;\n  border-radius: 5px;\n}\n.post3{\n  background-color:#e2e0e0;\n  width: 95%;\n  height: 450px;\n  border-radius: 5px;\n}\n.image-video{\n  background-color:#e2e0e0;\n  width: 100%;\n  height: 300px;\n}\n.text-static{\n  background-color:#e2e0e0;\n  width: 100%;\n  height: 42px;\n  border-radius: 5px;\n}\n.profilestatic{\n  background-color:#e2e0e0;\n  border-radius: 50%;\n  height: 30px;\n  width: 30px;\n}\n.profilestatic1 {\n  background-color:#e2e0e0;\n  height: 15px;\n  width: 182px;\n}\n.chatp-static{\n  background-color:#e2e0e0;\n  border-radius: 50%;\n  height: 50px;\n  width: 50px;\n}\n.chatt-static{\n  background-color:#e2e0e0;\n  height: 42px;\n  width: 316px;\n}\n.check-static{\n  width: 26px;\n  height: 26px;\n  border-radius: 50% ;\n background-color: #e2e0e0;\n}\n.date-static{\n  background-color:#e2e0e0;\n  height: 12px;\n  width: 130px;\n}\n.check-static1{\n  width: 22px;\n  height: 22px;\n  border-radius: 12% ;\n background-color: #e2e0e0;\n}\n.post4{\n  width: 95%;\n  height: 240px;\n}\n.post5{\n  width: 95%;\n  height: 100px;\n}\n.static-post{\n   background-color:#f2f2f2;\n   width: 100%;\n   height: 45px;\n   border-radius: 5px;\n}\n@media screen and  (max-width:576px){\n  .todos-pl{\n    padding-left: 8px !important;\n  }\n  .due-date{\n    display: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
